import { State } from './state'
import { Header } from '@/types/Header.type'

export const SET_CONFIGURATION = (state: any, { configuration }: any) => {
    state.configuration = configuration
}
export const SET_MAINTENANCE = (state: any, { maintenance }: any) => {
    state.maintenance = maintenance
}

export const UPDATE_PATH = (state: any, { path }: any) => {
    state.curentPath = path
}

export const SET_INPUT_DEVICE = (state: State, { audio, video }: any) => {
    if (audio !== undefined) {
        state.selectedDeviceId.audio = audio
    }

    if (video !== undefined) {
        state.selectedDeviceId.video = video
    }
}

export const SET_LAYOUT_COMPONENT = (state: State, component: any) => {
    state.layoutComponent = component
}

export const SET_LAYOUT_PROPS = (state: State, props: any) => {
    state.layoutProps = props
}

export const CLEAR_LAYOUT = (state: State) => {
    state.layoutComponent = null
    state.layoutProps = null
}

export const SET_HEADER_CONFIG = (state: State, value: Header) => {
    state.headerConfiguration = value
}
